export default __webpack_public_path__ + "static/media/bg-pattern-detail-footer.0e261449.svg";